import { defineMessages } from "react-intl";

const messages = defineMessages({
    help: {
        id: "intro.help",
    },
});

export default messages;
